import { RootState } from 'modules/store';
import { createSlice } from '@reduxjs/toolkit';
import { CorporateVerificationState, VerificationStatus } from './corporateVerification.types';
import {
  getCorporateBulkVerificationResult,
  getCorporateBulkVerificationResultData,
  getCorporateVerificationRecords,
  uploadCorporateBulkVerification,
} from './corporateVerification.actions';

const initialState: CorporateVerificationState = {
  verificationRecords: null,
  bulkVerificationResponse: null,
  bulkVerificationResult: null,
  bulkVerificationResultData: null,
  isFetchingVerificationRecords: false,
  isUploadingBulkVerification: false,
  isFetchingBulkVerificationResult: false,
  isFetchingVerificationResultData: false,
};

const corporateVerificationSlice = createSlice({
  name: 'corporateVerification',
  initialState,
  reducers: {
    resetBulkVerificationResultData: state => {
      state.bulkVerificationResultData = null;
      state.bulkVerificationResult = null;
      state.isFetchingVerificationResultData = false;
      state.isFetchingBulkVerificationResult = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(uploadCorporateBulkVerification.pending, state => {
      state.bulkVerificationResponse = null;
      state.isUploadingBulkVerification = true;
    });
    builder.addCase(uploadCorporateBulkVerification.fulfilled, state => {
      state.bulkVerificationResponse = null;
      state.isUploadingBulkVerification = false;
    });
    builder.addCase(uploadCorporateBulkVerification.rejected, (state, { payload }) => {
      if (payload) {
        state.bulkVerificationResponse = {
          status: VerificationStatus.failed,
          results_id: '',
          message: payload.message,
          timestamp: new Date().toISOString(),
          status_detail: {
            granular_status_code: payload.errorCode || '',
            status_additional_info: '',
          },
        };
      }
      state.isUploadingBulkVerification = false;
    });
    builder.addCase(getCorporateVerificationRecords.pending, state => {
      state.isFetchingVerificationRecords = true;
    });
    builder.addCase(getCorporateVerificationRecords.fulfilled, (state, { payload }) => {
      state.isFetchingVerificationRecords = false;
      state.verificationRecords = payload;
    });
    builder.addCase(getCorporateVerificationRecords.rejected, state => {
      state.isFetchingVerificationRecords = false;
    });
    builder.addCase(getCorporateBulkVerificationResult.pending, state => {
      state.isFetchingBulkVerificationResult = true;
    });
    builder.addCase(
      getCorporateBulkVerificationResult.fulfilled,
      (state, { payload }) => {
        state.isFetchingBulkVerificationResult = false;
        state.bulkVerificationResult = payload;
      },
    );
    builder.addCase(getCorporateBulkVerificationResult.rejected, state => {
      state.isFetchingBulkVerificationResult = false;
    });
    builder.addCase(
      getCorporateBulkVerificationResultData.pending,
      (state, { meta }) => {
        if (!meta.arg.isCsvFile) {
          state.isFetchingVerificationResultData = true;
        }
      },
    );
    builder.addCase(
      getCorporateBulkVerificationResultData.fulfilled,
      (state, { payload, meta }) => {
        if (!meta.arg.isCsvFile) {
          state.isFetchingVerificationResultData = false;
          state.bulkVerificationResultData = payload;
        }
      },
    );
    builder.addCase(getCorporateBulkVerificationResultData.rejected, state => {
      state.isFetchingVerificationResultData = false;
    });
  },
});

export default corporateVerificationSlice.reducer;
export const selectCorporateVerificationState = (state: RootState) => state.root.corporateVerification;
export const { resetBulkVerificationResultData } = corporateVerificationSlice.actions;

